import { render, staticRenderFns } from "./EditUserCompanies.vue?vue&type=template&id=7d06ff04&scoped=true"
import script from "./EditUserCompanies.vue?vue&type=script&lang=js"
export * from "./EditUserCompanies.vue?vue&type=script&lang=js"
import style0 from "./EditUserCompanies.vue?vue&type=style&index=0&id=7d06ff04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d06ff04",
  null
  
)

export default component.exports